module.exports = __webpack_public_path__ + "452792e606dbfd3e5c2683e99de7a80c.png";